import React from "react";
import { Layout } from "./components/layout/layout";

const App = () => {
  return <Layout />;
};

export default App;
